import { useDispatch } from 'react-redux'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { socialProjectBookingExportColumns } from '../../config/exportColumns/socialProjectBookingExportColumns'
import { appAllGetSocialProjectBooking } from '../../store/socialprojectbooking'
import { useState } from 'react'

function SocialProjectBooking() {
	const dispatch = useDispatch()

	const [exportFilters, setExportFilters] = useState({})
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Social Project Donation</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appAllGetSocialProjectBooking({
										...params,
										...exportFilters,
										sanstha: sansthaId || permissionOfSanstha,
										page: 1,
										limit: 10000,
										loading: false,
									}),
								)
							}
							columns={socialProjectBookingExportColumns}
							fileName="Social_Project_Donations"
							sheetName="Social Project Donations"
							buttonText="Export Donations"
						/>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default SocialProjectBooking
